import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {FeatureFilterConfiguration} from "./feature-filter-configuration";
import {GeoICONS} from "../components/icon/icon";

@JsonObject()
export class ViewManagerViewLayerConfiguration {
    @JsonProperty()
    declare id: string;
    @JsonProperty()
    declare layerId?: number;
    @JsonProperty()
    declare layerIds?: number[];
    constructor() {
    }
}
export class ViewManagerViewLayersConfiguration {
    @JsonProperty()
    declare open?: ViewManagerViewLayerConfiguration[];
    @JsonProperty()
    declare visible: ViewManagerViewLayerConfiguration[];
    constructor() {
    }
}
@JsonObject()
export class ViewManagerViewConfiguration {
    @JsonProperty()
    declare id: string;
    @JsonProperty()
    declare parentId?: string;
    /**
     * Short name ( used in site title)
     */
    @JsonProperty()
    declare name?: string;

    /**
     * Label for displaying
     */
    @JsonProperty()
    declare label: string;

    /**
     * Icon type
     */
    @JsonProperty()
    declare icon: GeoICONS;

    @JsonProperty()
    declare layers: ViewManagerViewLayersConfiguration;
    /**
     * filter to use for this topic
     */
    @JsonProperty()
    declare filter?: FeatureFilterConfiguration;
    /**
     * Base IDs contained within this topic
     * Used to find stations when addressed by url (station no is not unique)
     * Wird aktuell nur von Messdaten verwendet.
     */
    @JsonProperty()
    declare baseIds?: number[];

    /**
     * Routes to access this topic
     * Add "/" to load the topic at startup
     */
    @JsonProperty()
    declare routes: string[];

    constructor() {
    }
}
@JsonObject()
export class ViewManagerConfiguration {

    /**
     * Label für erste Auswahl
     *
     * @example: "Produkt wählen"
     */
    @JsonProperty()
    declare choose: string;
    @JsonProperty()
    declare default: string;
    /**
     * End displaying the maintenance information
     *
     * @example: "2020-11-27T18:30:00.000+01:00"
     */
    @JsonProperty()
    declare views: ViewManagerViewConfiguration[];

    constructor() {}
}
